import { useRecordContext, useTranslate } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";
import { DataTable } from "@/components/admin/data-table";
import { EditButton } from "@/components/admin/edit-button";
import { List } from "@/components/admin/list";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";
import { Badge } from "@/components/ui/badge";

import { TopToolbar } from "../layout/TopToolbar";
import { useConfigurationContext } from "../root/ConfigurationContext";
import type { Campaign } from "../types";
import { CampaignArchiveButton } from "./CampaignArchiveButton";

const CampaignListActions = () => (
  <TopToolbar>
    <CreateButton label="resources.campaigns.action.new" />
  </TopToolbar>
);

const RevistaFilterInput = () => {
  const { revistas } = useConfigurationContext();
  const choices = (revistas || []).map((r) => ({ id: r.value, name: r.label }));
  return <SelectInput source="revista" choices={choices} label="Revista" />;
};

const TipoFilterInput = () => {
  const translate = useTranslate();
  const choices = [
    {
      id: "edicao",
      name: translate("resources.campaigns.tipos.edicao", { _: "Edição" }),
    },
    {
      id: "periodo",
      name: translate("resources.campaigns.tipos.periodo", { _: "Período" }),
    },
    {
      id: "evento",
      name: translate("resources.campaigns.tipos.evento", { _: "Evento" }),
    },
  ];
  return <SelectInput source="tipo" choices={choices} label="Tipo" />;
};

const filters = [
  <SearchInput source="q" alwaysOn key="q" />,
  <TipoFilterInput key="tipo" />,
  <RevistaFilterInput key="revista" />,
];

const TipoField = () => {
  const record = useRecordContext<Campaign>();
  const translate = useTranslate();
  if (!record) return null;

  const labels: Record<string, string> = {
    edicao: translate("resources.campaigns.tipos.edicao", { _: "Edição" }),
    periodo: translate("resources.campaigns.tipos.periodo", { _: "Período" }),
    evento: translate("resources.campaigns.tipos.evento", { _: "Evento" }),
  };

  return <Badge variant="outline">{labels[record.tipo] || record.tipo}</Badge>;
};

const ActionsColumn = () => {
  const record = useRecordContext<Campaign>();
  if (!record) return null;
  return (
    <div className="flex items-center gap-2">
      <EditButton record={record} />
      <CampaignArchiveButton record={record} />
    </div>
  );
};

export function CampaignList() {
  return (
    <List
      filters={filters}
      actions={<CampaignListActions />}
      filter={{ "archived_at@is": null }}
      sort={{ field: "data_inicio", order: "DESC" }}
    >
      <DataTable>
        <DataTable.Col source="name" />
        <DataTable.Col source="tipo">
          <TipoField />
        </DataTable.Col>
        <DataTable.Col source="revista" />
        <DataTable.Col source="data_inicio" />
        <DataTable.Col source="data_fim" />
        <DataTable.Col label={false}>
          <ActionsColumn />
        </DataTable.Col>
      </DataTable>
    </List>
  );
}
